import { costGuideLocation_costGuideLocation_CostGuideLocationSuccess_cityList as costGuideLocationCityList } from '@/__generated__/costGuideLocation';
import { TypeAheadOptions } from '@/types/common';

export const createTypeAheadOptions = (
  cityList: costGuideLocationCityList[] | []
): TypeAheadOptions[] => {
  if (cityList.length < 1) {
    return [];
  }
  return cityList.map((entry) => ({
    label: `${entry.location.city}, ${entry.location.state.stateCode}`,
    value: entry.slug,
  }));
};
